module.exports = __webpack_public_path__ + "assets/img/btn-view-25b7c1ca.png";